import { memo } from "react";

type Props = {
	content: string;
};

export const BlankContentForList = memo(({ content }: Props) => {
	return (
		<div className="rounded bg-bg-layer-200 p-4 text-center text-sm md:text-base">
			<p className=" whitespace-pre-line">{content}</p>
		</div>
	);
});
